import React, { useState } from 'react';
import image from './doubt.png';
import ContactForm from './ReachOut/Contact';

const DoubtSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Function to handle opening the modal
  const openModal = () => {
    setIsModalOpen(true);
  };

  // Function to handle closing the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="bg-gray py-12 flex justify-center items-center rounded-3xl">
      <div className="bg-white rounded-3xl shadow-lg p-10 flex items-center justify-between w-10/12">
        {/* Left Section with Image */}
        <div className="flex-1">
          <img
            src={image}
            alt="Confused Person"
            className="max-w-full"
          />
        </div>

        {/* Right Section with Text */}
        <div className="flex-1 text-center space-y-4">
          <h2 className="text-3xl font-bold text-[#244849]">In doubt? Can't decide?</h2>
          <p className="text-gray-500">
            Don’t hesitate & hand over your queries to our travel experts and let them assist you
            with their authentic traveling insights.
          </p>

          <button
            className="bg-[#244849] text-white py-2 px-6 rounded-full hover:bg-[#1c3b3c] transition duration-300"
            onClick={openModal}  // Open modal on click
          >
            Get a Quote
          </button>
          <p className="text-gray-400 italic">We're always excited to pick up your calls</p>
        </div>
      </div>

      {/* Modal Section */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-[#1c3b3c] bg-opacity-50  flex items-center justify-center z-50 w-[600px]">
              <button
              className="absolute top-4 right-4 text-white text-2xl"
              onClick={closeModal}
            >
              &times;
            </button>
          <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md relative">
            {/* Close button */}
          
            
            {/* Contact Form */}
            <ContactForm />

          </div>
        </div>
      )}
    </div>
  );
};

export default DoubtSection;
